<template>
  <div id="sideBar" class="mb-3">
    <ul style="list-style: none;padding-bottom: 20px">
      <li class="active-list" id="user-home" @click="changeBackground">
        <router-link to="/dashboard">
          <div class="row" style="display: flex">
            <div class="col-4 text-center">
              <img
                :src="user.photoURL"
                alt=""
                class="img-responsive  ml-1"
                style="width: 60px; height: 60px; border-radius: 50%;"
              />
            </div>
            <div class="col-8 text-white">
              <h4
                class="mb-0"
                style="font-weight: bold; font-size: 18px; margin-top: 10px"
              >
                {{ user.name }}
              </h4>
              <small style="font-size: 12px">{{ user.email }}</small>
            </div>
          </div>
        </router-link>
      </li>
      <li>
        <div class="text-center">
          <button
            class="btn btn-primary btn-block"
            data-toggle="modal"
            data-target="#organisation"
          >
            <svg
                width="25"
                height="25"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style="width: 25px;"
              >
                <image
                  href="../../assets/new-organisation.svg"
                  width="100%"
                />
              </svg>
              New Organisation
          </button>
        </div>
      </li>
      <li v-if="organizations.length > 0">
        <h6>
          <span class="bg-light">ORGANISATION</span>
        </h6>
      </li>
      <li
        v-for="(o, i) in organizations"
        :key="i"
        @click="changeBackground"
        class="organization"
        :id="o.org_id"
      >
        <router-link :to="'/organization/' + o.org_id" :key="$route.fullPath">
          <div class="row" style="display: flex;">
            <div v-if="o.org_logo !== ''" class="col-2 text-center">
              <img
                :src="o.org_logo"
                :alt="o.org_name"
                style="width: 40px; height: 40px; border-radius: 50%;"
              />
            </div>
            <div v-else class="col-2 text-center">
              <img
                src="../../assets/community-img.png"
                :alt="o.org_name"
                style="width: 40px; height: 40px; border-radius: 50%;"
              />
            </div>
            <div class="col-9 ml-1">
              <h4
                class="mb-0 ml-2 text-white"
                style="font-weight: bold; font-size: 15px; margin-top: 10px;"
              >
                {{ o.org_name }}
              </h4>
            </div>
          </div>
        </router-link>
      </li>
      
    </ul>
    <!--					<router-link to="/dashboard/create-event" class="btn btn-primary btn-block text-dark"><b>Create Event</b></router-link>-->
    <br />

    <!-- Modal -->
    
    <div
      class="modal "
      id="organisation"
      tabindex="-1"
      role="dialog"
      aria-labelledby="organisation"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Create Organization
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              id="close-create-org"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group text-left">
              <label>Organization Name *</label>
              <input
                type="text"
                class="form-control"
                id="nav-channel"
                min="1"
                max="50"
                placeholder="Enter organization name"
                v-model="org_name"
              />
            </div>
            <div class="form-group text-left">
              <label>Email</label>
              <input
                type="text"
                class="form-control"
                min="1"
                id="nav-participants"
                placeholder="Enter organization's official email"
                v-model="org_email"
              />
            </div>
            <div class="form-group">
              <div v-if="org_logo === ''">
                <label>Choose Logo</label>
                <vue-dropzone
                  ref="myVueDropzone"
                  :options="dropzoneOptions"
                  :awss3="awss3"
                  v-on:vdropzone-s3-upload-error="s3UploadError"
                  v-on:vdropzone-s3-upload-success="s3UploadSuccess"
                  id="dropzone"
                  v-on:vdropzone-file-added="vfileAdded"
                  style="background: #1B1B1B"
                >
                </vue-dropzone>
              </div>
              <div v-else class="mb-2">
                <div class="mb-2">
                  <label>Choose Logo</label>
                  <button
                    class="btn btn-outline-danger btn-sm"
                    style="float:right;"
                    @click="org_logo = ''"
                  >
                    Change Image
                  </button>
                </div>
                <div class="text-center">
                  <img
                    :src="org_logo"
                    :alt="org_name"
                    style="width: 100px; height: 100px; border-radius: 50%;"
                  />
                </div>
              </div>
            </div>
            <div
              class="form-check"
              style="margin-top: -10px; margin-bottom: 10px"
            >
              <input
                type="checkbox"
                class="form-check-input"
                id="org_checkbox"
                v-model="org_checkbox"
              />
              <label class="form-check-label" for="org_checkbox">
                Accept
                <a href="https://meetbeans.com/privacy-policy" target="_blank"
                  >terms and conditions</a
                >
                *.</label
              >
            </div>
            <div class="text-center mt-2">
              <button
                type="button"
                class="btn btn-primary"
                @click="submitOrganization"
              >
                Create
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import jquery from "jquery";
export default {
  name: "side-bar",
  data() {
    return {
      user: {},
      organizations: [],
      org_name: "",
      org_email: "",
      org_logo: "",
      org_checkbox: false,
      baseUrl: this.$store.state.baseUrl,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        maxFilesize: 10,
        maxFiles: 1,
        acceptedFiles: "image/*",
        params: {
          success_action_status: 201,
        },
        addRemoveLinks: true,
        headers: { "Access-Control-Allow-Origin": "*" },
        dictDefaultMessage:
          'UPLOAD <i class="fas fa-upload"></i> <br> <small style=\'font-size:10px;\'><i class="fas fa-info-circle text-info"></i> This will give others an idea about the organization</small>',
      },
      awss3: {
        signingURL: this.baseUrl + "/signature", //Where you will get signed url
        headers: {},
        params: {},
        sendFileToServer: true, //If you want to upload file to your server along with s3
        withCredentials: false,
      },
      currentTarget: {},
    };
  },
  props: {
    org_id: String,
  },
  components: {
    vueDropzone: vue2Dropzone,
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("user_info"));
    if (this.user === null) {
      this.$router.push("/");
    }
    this.getOrganizations();

    if (this.$route.params.id !== "" || this.$route.params.id !== undefined) {
      console.log("beforeCreate2", jquery(`#${this.$route.params.id}`));

      jquery(`#${this.$route.params.id}`).addClass("active-list");
      // console.log("Hellooooo");

      document
        .getElementById(this.$route.params.id)
        .classList.add("active-list");
      document.getElementById("user-home").classList.remove("active-list");
    } else {
      //   console.log("Hello");
      document.getElementById("user-home").classList.add("active-list");
    }
  },
  mounted() {
    this.$root.$on("updateUserInfo", (user) => {
      this.user = user;
    });
    this.$root.$on("getUpdatedOrgsList", () => {
      this.getOrganizations();
    });
    if (window.innerWidth <= 600) {
      document.getElementById("sideBar").style.height = "auto";
    }
  },
  updated() {
    if (this.$route.params.id !== "" && this.$route.params.id !== undefined) {
      console.log("beforeCreate2", jquery(`#${this.$route.params.id}`));

      jquery(`#${this.$route.params.id}`).addClass("active-list");

      document.getElementById("user-home").classList.remove("active-list");
    } else {
      document.getElementById("user-home").classList.add("active-list");
    }
  },

  methods: {
    changeBackground(e) {
      jquery("ul li").removeClass("active-list");
      jquery(e.currentTarget).addClass("active-list");
    },
    vfileAdded(file) {
      console.log(file);
      let file_name = file.name;
      this.awss3.signingURL = this.baseUrl + "/signature/" + file_name;
      this.dropzoneOptions.url = this.baseUrl + "/signature/" + file_name;
    },
    s3UploadError(errorMessage) {
      console.log(errorMessage);
    },
    s3UploadSuccess(s3ObjectLocation) {
      this.org_logo = s3ObjectLocation;
    },
    getOrganizations() {
      const $ = this;
      $.$store.dispatch("getOrganization").then((resp) => {
        if (resp.data.status === "success") {
          $.organizations = resp.data.data;
        } else {
          $.$toast.open({
            message: resp.data.data,
            type: "error",
            position: "top",
            queue: true,
          });
        }
      });
    },
    submitOrganization() {
      const $ = this;
      if ($.org_name === "") {
        $.$toast.open({
          message: "Organization name is required.",
          type: "error",
          position: "top",
          queue: true,
        });
      } else if ($.org_checkbox === false) {
        $.$toast.open({
          message: "Please accept terms and condition.",
          type: "error",
          position: "top",
          queue: true,
        });
      } else {
        let data = {
          org_name: $.org_name,
          org_email: $.org_email,
          org_logo: $.org_logo,
        };
        $.$store.dispatch("createOrganization", data).then((resp) => {
          if (resp.data.status === "success") {
            $.$toast.open({
              message: "Organization successfully created.",
              type: "success",
              position: "top",
              queue: true,
            });
            document.getElementById("close-create-org").click();
            $.getOrganizations();
            $.org_name = "";
            $.org_email = "";
            $.org_logo = "";
            $.org_checkbox = false;
            $.$router.push("/organization/" + resp.data.data);
          } else {
            $.org_checkbox = false;
            $.$toast.open({
              message: resp.data.data,
              type: "error",
              position: "top",
              queue: true,
            });
          }
        });
      }
    },
  },
};
</script>

<style scoped>
#sideBar {
  height: 90vh;
  overflow-y: scroll;
}
@media screen and (max-width: 768px) {
  #sideBar {
    height: auto;
    margin-bottom: 50px;
  }
}
h6 {
  margin: 10px 0px;
  font-size: 10px;
  font-weight: bold;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid rgb(87, 81, 81);
  line-height: 0;
}

h6 span {
  padding: 5px 30px;
  border-radius: 3px;
}
.active-list {
  background: #344c67;
  border-radius: 10px;
  padding: 10px;
}
ul {
  margin: 0;
  padding: 0px;
}
ul li {
  padding: 10px;
  margin: 10px;
}
ul .organization:hover {
  background: #000;
  border-radius: 12px;
}
.vue-dropzone {
  border-radius: 10px;
  background: #000 !important;
  border: 1px solid;
}
</style>
